






import Vue from 'vue'
import Config from '@/types/config'
import { Route } from 'vue-router'
import LinkButton from '@/components/shared/atoms/Button/LinkButton'

export default Vue.extend({
  components: {
    LinkButton
  },
  props: {
    redirectTo: {
      type: String,
      default: ''
    },
    forwardedParams: {
      type: Object as () => Route['params'],
      required: true
    },
    forwardedQueries: {
      type: Object as () => Route['query'],
      required: true
    }
  },
  computed: {
    yLoginPath(): string {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const appConfig = (process.env.APP_CONFIG as any) as Config['app']
      const serverUrl = appConfig ? appConfig.services['snapsnap'].host : ''

      // TODO: use helper
      const redirectParameterStr = Object.keys(this.forwardedParams)
        .filter(key => !!this.forwardedParams[key])
        .map(key => `${key}=${this.forwardedParams[key]}`)
        .join('&')
      const redirectQueryStr = Object.keys(this.forwardedQueries)
        .filter(key => !!this.forwardedQueries[key])
        .map(key => `${key}=${this.forwardedQueries[key]}`)
        .join('&')
      const additionalParams = this.redirectTo
        ? `?callback=${this.redirectTo}${redirectParameterStr && '&' + redirectParameterStr}${redirectQueryStr && '&' + redirectQueryStr}&presetEmail=${this.forwardedQueries.email}`
        : ''
      return serverUrl + '/tpoint/login' + additionalParams
    }
  }
})
